var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('sign-in',{attrs:{"ifShow":_vm.signInShow},on:{"update:ifShow":function($event){_vm.signInShow=$event},"update:if-show":function($event){_vm.signInShow=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }